import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setOffSeasonEvent,
  setSelectedEvent,
  setVideoList,
} from "../../../Redux/Actions/PastSeasonActions";
import PastSeasonColumnContainer from "./PastSeasonColumnContainer";

const EventList = ({
  active,
  setActive,
  setActiveOffSeasonEvent,
  setActiveOtherSeasonEvent,
  setActiveEventTypeOfWeek,
  setExpanded,
}) => {
  const dispatch = useDispatch();
  const selectedSeasonData = useSelector(
    (state) => state.selectedSeasonData.selectedSeasonData
  );
  const Events = [
    {
      id: 1,
      EventName: "In Season",
    },
    {
      id: 2,
      EventName: "Off Season",
    },
    {
      id: 3,
      EventName: "Other",
    },
  ];

  const handleEventClick = (el) => {
    if (active?.id === el.id) {
      setActive(null);
      setSelectedEvent(dispatch, null);
    } else {
      switch (el.EventName) {
        case "In Season":
          setSelectedEvent(dispatch, selectedSeasonData?.inSeasonData);
          break;
        case "Off Season":
          setSelectedEvent(dispatch, selectedSeasonData?.offSeasonData);
          break;
        case "Other":
          setSelectedEvent(dispatch, selectedSeasonData?.otherSeasonData);
          break;

        default:
          break;
      }
      setActive(el);
    }
    setActiveOffSeasonEvent(null);
    setVideoList(dispatch, null);
    setOffSeasonEvent(dispatch, null);
    setActiveOtherSeasonEvent(null);
    setActiveEventTypeOfWeek(null);
    setExpanded(null);
  };
  return (
    <>
      {typeof selectedSeasonData === "object" &&
      Object.keys(selectedSeasonData).length ? (
        <PastSeasonColumnContainer
          heading={"Event's"}
          data={Events}
          handleClick={handleEventClick}
          active={active}
          fieldToShow={"EventName"}
          isObject={false}
        />
      ) : null}
    </>
  );
};

export default EventList;
